export const DATA_TABLE_LIST = [

    {
        'key': 'invblncskutd',
        'value': 'Commodity',
    },
    {
        'key': 'invskufacilitytd',
        'value': 'Commodity by Facility',
    },
    {
        'key': 'invskuloctd',
        'value': 'Commodity by Location',
    },
    {
        'key': 'invidtd',
        'value': 'ID',
    },
    {
        'key': 'invlocationtd',
        'value': 'Location',
    },
    {
        'key': 'invlottd',
        'value': 'Lot',
    },
    {
        'key': 'invlotidtd',
        'value': 'Lot by ID',
    },
    {
        'key': 'invlotloctd',
        'value': 'Lot by Location',
    },
    {
        'key': 'invlotlocidtd',
        'value': 'Lot by Location by ID',
    },
    {
        'key': 'invstorertd',
        'value': 'Storer',
    },
    {
        'key': 'invskulocucctd',
        'value': 'Commodity by Location by UCC',
    },
    {
        'key': 'invlotlociducctd',
        'value': 'Lot by Location by ID by UCC',
    },
    {
        'key': 'invlotlocidcasestd',
        'value': 'Lot by Location by ID in Cases',
    }
];




// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/control/inventory-balance/service/inventory-balance-tables.ts